// v4.6 — Page section Kiosque (/kiosque/section/:sectionId) — « Voir tout » et catégories populaires.
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import CatalogCrossPromo from "@/components/content/CatalogCrossPromo";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const SECTIONS = {
  tout: { title: "Tout le Kiosque", match: () => true },
  presse: { title: "📰 Presse — À la une", match: (it) => !it.kind || it.kind === "presse" || it.kind === "journal" },
  romans: { title: "📖 Romans", match: (it) => it.kind === "roman" },
  livres: { title: "📖 Livres & Romans", match: (it) => it.kind === "roman" || it.kind === "livre" },
  contes: { title: "🕷️ Contes & Traditions", match: (it) => it.kind === "conte" },
  stories: { title: "✍🏾 AYA Stories", match: (it) => it.kind === "story" },
  audio: { title: "🎧 Livres audio", match: (it) => it.kind === "audio" },
  jeunesse: { title: "🧒🏾 Jeunesse", match: (it) => it.kind === "jeunesse" },
  education: { title: "🎓 Éducation", match: (it) => it.kind === "education" },
  magazines: { title: "💄 Magazines", match: (it) => it.kind === "magazine" },
};

export default function KiosqueSectionPage() {
  const navigate = useNavigate();
  const { sectionId } = useParams();
  const section = SECTIONS[sectionId] || SECTIONS.tout;
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/v3/content/discover`)
      .then((r) => setItems((r.data?.items || []).filter(section.match)))
      .catch(() => setItems([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionId]);

  return (
    <div className="min-h-screen bg-[#0a0a0d] text-white pb-16" data-testid="kiosque-section-page">
      <div className="sticky top-0 z-10 bg-[#0a0a0d]/95 backdrop-blur border-b border-white/8">
        <div className="max-w-3xl mx-auto flex items-center gap-3 px-4 py-3">
          <button onClick={() => navigate("/kiosque")} className="p-1.5 -ml-1.5 rounded-full hover:bg-white/10 text-white/80" data-testid="section-back-btn">
            <ArrowLeft size={19} />
          </button>
          <div className="text-[15px] font-bold">{section.title}</div>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 py-5 space-y-6">
        {items === null ? (
          <div className="grid grid-cols-2 gap-3">{[...Array(4)].map((_, i) => <div key={i} className="aspect-[3/4.4] rounded-2xl bg-white/[0.05] animate-pulse" />)}</div>
        ) : items.length === 0 ? (
          <div className="text-center py-10 space-y-2" data-testid="section-empty">
            <div className="text-3xl">✨</div>
            <div className="text-[14px] font-bold">Les premiers titres arrivent bientôt</div>
            <div className="text-[12px] text-white/50">Cette section du Kiosque est en cours d'enrichissement.</div>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="section-grid">
            {items.map((it) => (
              <button key={it.id} onClick={() => navigate(`/kiosque?open=${it.id}`)} data-testid={`section-item-${it.id}`} className="text-left">
                <div className="relative aspect-[3/4] rounded-xl overflow-hidden border border-white/12 bg-white/[0.05]">
                  {it.cover_url && <img src={it.cover_url.startsWith("http") ? it.cover_url : `${BACKEND_URL}${it.cover_url}`} alt={it.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />}
                  {typeof it.price_fcfa === "number" && (
                    <span className="absolute bottom-2 left-2 text-[10.5px] font-extrabold px-2.5 py-1 rounded-lg bg-black/85 text-amber-300 border border-amber-400/60">{it.price_fcfa} FCFA</span>
                  )}
                </div>
                <div className="mt-1.5 text-[12.5px] font-bold leading-tight truncate">{it.title}</div>
              </button>
            ))}
          </div>
        )}
        <CatalogCrossPromo src="kiosque" compact />
      </div>
    </div>
  );
}
